import axios from "axios";
import { api } from "./api_client";
import { Flight } from "../models/flight";

export default async function fetchFlightPath(
  flight: Flight,
  signal?: AbortSignal
): Promise<[lat: number, lon: number][]> {
  try {
    const response = await api.get(`/flights/${flight.id}/path`, {
      signal,
    });
    return response.data.path;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request aborted");
    } else if (axios.isAxiosError(error) && error.response?.status === 404) {
      return [];
    } else {
      console.error("Error fetching data:", error);
    }

    throw error;
  }
}
